import React from "react";

interface AvalancheIconProps {
  avalancheType: string;
  style?: React.CSSProperties;
}

class AvalancheIcon extends React.Component<AvalancheIconProps> {
  getAvalancheIcon(avalancheType: string) {
    const path = `../../icons/${avalancheType}.png`;
    return <img src={path} alt="" style={this.props.style} />;
  }

  render() {
    const { avalancheType } = this.props;
    return this.getAvalancheIcon(avalancheType);
  }
}

export default AvalancheIcon;
